import React from "react";
import { Box, Typography } from "@mui/material";

function ToggleKnob({ checked }) {
  return (
    <Box
      sx={{
        width: 36,
        height: 20,
        borderRadius: "10px",
        backgroundColor: checked ? "text.primary" : "action.selected",
        position: "relative",
        flexShrink: 0,
        transition: "background-color 0.15s",
      }}
    >
      <Box
        sx={{
          width: 16,
          height: 16,
          borderRadius: "50%",
          backgroundColor: "background.paper",
          position: "absolute",
          top: 2,
          left: checked ? 18 : 2,
          transition: "left 0.15s",
        }}
      />
    </Box>
  );
}

export default function ToggleRow({ checked, onChange, title, description }) {
  const handleToggle = () => onChange(!checked);
  const handleKeyDown = (event) => {
    if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      handleToggle();
    }
  };

  return (
    <Box
      onClick={handleToggle}
      onKeyDown={handleKeyDown}
      role="switch"
      tabIndex={0}
      aria-checked={checked}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 1.5,
        py: 1.25,
        borderRadius: "8px",
        border: "1px solid",
        borderColor: "divider",
        cursor: "pointer",
        "&:hover": { borderColor: "text.disabled" },
        "&:focus-visible": {
          outline: "2px solid",
          outlineColor: "text.primary",
          outlineOffset: 2,
        },
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 500, color: "text.primary" }}>
          {title}
        </Typography>
        {description && (
          <Typography
            sx={{ fontSize: 12, color: "text.disabled", lineHeight: 1.3, mt: 0.25 }}
          >
            {description}
          </Typography>
        )}
      </Box>
      <ToggleKnob checked={checked} />
    </Box>
  );
}

export { ToggleKnob };
